import { PlusOutlined } from "@ant-design/icons";
import React from "react";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

const PromotionalCard = ({
  id,
  icon,
  title,
  description,
  isActive,
  setSelectedPromo,
  setActivePromoVariant,
}) => {
  const handleSelectPromo = () => {
    setSelectedPromo(id);
    setActivePromoVariant(id);
  };
  return (
    <article
      className={` ${
        isActive ? "promotionalCard promotionalCard-active" : "promotionalCard"
      }`}
    >
      <header className="cardHeader">
        <img src={icon} className="cardIcon" alt="" />
        <button
          className="iconButton"
          onClick={handleSelectPromo}
          type="button"
          aria-label={AppStrings.PAM_NEW_PROMOTION_ACTION_BUTTON_ARIA}
        >
          <PlusOutlined className="actionIcon" />
        </button>
      </header>
      <div className="cardContent">
        <h2 className="cardTitle">{title}</h2>
        <p className="cardDescription">{description}</p>
      </div>
    </article>
  );
};

export default PromotionalCard;
